(() => {
  const journey = document.querySelector('[data-story-journey]');
  if (!journey) return;
  const items = [...journey.querySelectorAll('.jt-item')];
  const year = journey.querySelector('#jtYear');
  const index = journey.querySelector('#jtIdx');
  const fill = journey.querySelector('#jtFill');
  let pending = false;
  function update() {
    const marker = innerHeight * .45;
    let active = 0;
    items.forEach((item, i) => { if (item.getBoundingClientRect().top < marker) active = i; });
    year.textContent = items[active].dataset.year;
    index.textContent = String(active + 1);
    fill.style.height = ((active + 1) / items.length * 100) + '%';
    pending = false;
  }
  function schedule() { if (!pending) { pending = true; requestAnimationFrame(update); } }
  addEventListener('scroll', schedule, { passive: true });
  addEventListener('resize', schedule);
  update();
})();

(() => {
  const reviews = document.querySelector('[data-story-reviews]');
  const dialog = document.querySelector('.pu-story-review-dialog');
  if (!reviews) return;
  const motion = reviews.querySelector('[data-review-motion]');
  const reduced = matchMedia('(prefers-reduced-motion: reduce)');
  reviews.querySelectorAll('.pu-story-review-set').forEach(set => {
    const clone = set.cloneNode(true);
    clone.setAttribute('aria-hidden', 'true');
    clone.querySelectorAll('a').forEach(link => link.tabIndex = -1);
    set.parentElement.append(clone);
  });
  reviews.classList.add('is-enhanced');
  function motionPreference() { motion.hidden = reduced.matches; }
  reduced.addEventListener('change', motionPreference);
  motionPreference();
  motion.addEventListener('click', () => {
    const paused = reviews.classList.toggle('is-paused');
    motion.textContent = paused ? 'Resume scrolling' : 'Pause scrolling';
  });
  if ('IntersectionObserver' in window) {
    new IntersectionObserver(entries => {
      reviews.classList.toggle('is-out-of-view', !entries[0].isIntersecting);
    }).observe(reviews);
  }
  // Only keyboard focus may reset the moving rail; pointer taps must not move their target.
  let keyboardNavigation = false;
  document.addEventListener('keydown', event => { if (event.key === 'Tab') keyboardNavigation = true; }, true);
  document.addEventListener('pointerdown', () => { keyboardNavigation = false; }, true);
  reviews.addEventListener('focusin', event => {
    if (keyboardNavigation && event.target.matches('[data-review-video]')) {
      reviews.classList.add('is-browsing');
      event.target.scrollIntoView({ block:'nearest' });
    }
  });
  reviews.addEventListener('focusout', event => {
    if (!reviews.contains(event.relatedTarget)) reviews.classList.remove('is-browsing');
  });
  if (!dialog || typeof dialog.showModal !== 'function') return;
  let opener;
  reviews.addEventListener('click', event => {
    const link = event.target.closest('[data-review-video]');
    if (!link || !reviews.contains(link)) return;
    event.preventDefault();
    opener = link;
    dialog.querySelector('h2').textContent = link.dataset.reviewPerson;
    dialog.querySelector('.pu-story-review-dialog__source').href = link.href;
    const iframe = document.createElement('iframe');
    iframe.src = link.dataset.reviewVideo + '?autoplay=1&playsinline=1';
    iframe.title = link.dataset.reviewPerson + ' customer video';
    iframe.allow = 'autoplay; encrypted-media; picture-in-picture';
    iframe.allowFullscreen = true;
    dialog.querySelector('.pu-story-review-dialog__media').replaceChildren(iframe);
    reviews.classList.add('is-paused');
    motion.textContent = 'Resume scrolling';
    dialog.showModal();
    dialog.querySelector('[data-review-close]').focus();
  });
  dialog.querySelector('[data-review-close]').addEventListener('click', () => dialog.close());
  dialog.addEventListener('keydown', event => {
    if (event.key === 'Escape') { event.preventDefault(); event.stopPropagation(); dialog.close(); }
  });
  dialog.addEventListener('click', event => {
    const rect = dialog.getBoundingClientRect();
    if (event.target === dialog && (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom)) dialog.close();
  });
  dialog.addEventListener('close', () => {
    dialog.querySelector('.pu-story-review-dialog__media').replaceChildren();
    if (opener) opener.focus({ preventScroll:true });
  });
})();

(() => {
  const source = document.querySelector('[data-alan-source]');
  const dialog = document.querySelector('#pu-story-alan-dialog');
  const opener = document.querySelector('[data-alan-open]');
  if (!source || !dialog || typeof dialog.showModal !== 'function') return;
  const content = source.querySelector('[data-alan-content]');
  source.hidden = true;
  document.querySelector('[data-alan-action]').hidden = false;
  opener.addEventListener('click', () => {
    dialog.querySelector('.pu-story-alan-dialog__body').append(content);
    dialog.showModal();
    dialog.scrollTop = 0;
    dialog.querySelector('[data-alan-close]').focus();
  });
  dialog.querySelector('[data-alan-close]').addEventListener('click', () => dialog.close());
  dialog.addEventListener('keydown', event => {
    if (event.key === 'Escape') { event.preventDefault(); event.stopPropagation(); dialog.close(); }
  });
  dialog.addEventListener('click', event => {
    const rect = dialog.getBoundingClientRect();
    if (event.target === dialog && (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom)) dialog.close();
  });
  dialog.addEventListener('close', () => {
    source.append(content);
    opener.focus({ preventScroll:true });
  });
})();
